import React from 'react';
import PropTypes from 'prop-types';
import Footer from './common/Footer';
import SimpleField from '@/js/components/common/SimpleField';
import '../../scss/components/ChangePassword.scss';
import { genericOnChangeCreator, genericOnBlurCreator } from '@/js/formHelpers';
import { required } from '@/js/validators';
import { clone } from '@/js/util';

class ChangePasswordForm extends React.PureComponent {
	constructor(props) {
		super(props);
		this.onSubmit = this.onSubmit.bind(this);
		this.validatePasswords = this.validatePasswords.bind(this);
		this.validateVerifyPassword = this.validateVerifyPassword.bind(this);
		this.validateNewPasswordCriteria = this.validateNewPasswordCriteria.bind(this);
		this.validateNewPasswordOnBlur = this.validateNewPasswordOnBlur.bind(this);
		this.validateNewPasswordOnChange = this.validateNewPasswordOnChange.bind(this);

		this.state = {
			values: { currentPassword: '', newPassword: '', verifyPassword: '' },
			meta: { currentPassword: { touched: false, errorMessage: '' },
					newPassword: { touched: false, errorMessage: ''},
					verifyPassword: { touched: false, errorMessage: ''}
			}
		};
	}

	componentWillReceiveProps(nextProps) {
		if(nextProps.formErrorMessage) {
			let metaKey = '';
			if(nextProps.formErrorMessage.includes('Password is incorrect.')) {
				metaKey = 'currentPassword';
			} else {
				metaKey = 'newPassword';
			}

			this.setState(prevState => {
				let newState = clone(prevState);
				newState.meta[metaKey] = { errorMessage: nextProps.formErrorMessage, touched: true};
				return newState;
			});
		}
	}

	validateCurrentPassword(val) {
		return required(val, 'Current password');
	}

	validateNewPasswordCriteria(val) {
		let error = required(val, 'New password');
		if(error) {
			return error;
		}
		else {
			let categories = 0;
			if(/[A-Z]+/.test(val)) categories++;
			if(/[a-z]+/.test(val)) categories++;
			if(/[0-9]+/.test(val)) categories++;
			if(/[!@#$%^&*()]+/.test(val)) categories++;

			if(categories < 4 || val.length < 12) {
				error = this.props.label.newPassword;
			}
		}
		return error;
	}

	validateNewPasswordOnBlur(val) {
		return this.validateNewPasswordCriteria(val);
	}

	validateNewPasswordOnChange(val) {
		if(!this.state.meta.newPassword.valid) {
			return this.validateNewPasswordCriteria(val);
		}
	}

	validateVerifyPassword(val) {
		let error = required(val, 'Confirm new password');
		if(error) {
			return error;
		} else if (val !== this.state.values.newPassword) {
			error = this.props.label.verifyPassword;
		}
		return error;
	}

	validatePasswords(currentPassword, newPassword, verifyPassword){
		let errors = {};
		if(!currentPassword && !this.props.hidePassword) {
			errors.currentPassword = this.validateCurrentPassword(currentPassword);
		}
		errors.newPassword = this.validateNewPasswordCriteria(newPassword);
		errors.verifyPassword = this.validateVerifyPassword(verifyPassword);

		return errors;
	}

	onSubmit(e) {
		e.preventDefault();

		let errors = this.validatePasswords(this.state.values.currentPassword, this.state.values.newPassword, this.state.values.verifyPassword);
		//Removes undefined keys
		if (Object.values(errors).filter((e) => e).length > 0) {
			this.setState(prevState => {
				let newState = clone(prevState);
				for (let metaKey in errors) {
					if(errors[metaKey]) {
						newState.meta[metaKey] = { errorMessage: errors[metaKey], touched: true };
					}
				}
				return newState;
			});
		} else {
			this.props.onSubmitCallback(this.state.values);
		}
	}

	render() {
		if(/:\/\//.test(this.props.redirect)) {
			window.location = this.props.redirect;
		} else if(this.props.redirect.length > 0) {
			window.location.pathname = this.props.redirect;
		}

		return (
			<div className='ChangePasswordForm col-12 col-md-8 mx-auto'>
				<h1 className='h2'>Change Password</h1>
				<div className='ChangePasswordCard card mb-3'>
					<div className='card-body'>
						<form onSubmit={this.onSubmit}>
							<div className='row'>
								<div className='col-12 col-lg-6 mb-3'>
									{!this.props.hidePassword &&
										<SimpleField name="current_password"
											id="currentPassword"
											label="Current password"
											type="password"
											maxLength={65}
											value={this.state.values.currentPassword}
											touched={this.state.meta.currentPassword.touched}
											errorMessage={this.state.meta.currentPassword.errorMessage}
											onChange={genericOnChangeCreator(this, 'currentPassword', this.validateCurrentPassword)}
											onBlur={genericOnBlurCreator(this, 'currentPassword', this.validateCurrentPassword)}
											validationIconClass="validationErrorIcon"
										/>
									}
									<SimpleField name="new_password"
										id="newPassword"
										label="New password"
										type="password"
										maxLength={65}
										value={this.state.values.newPassword}
										touched={this.state.meta.newPassword.touched}
										errorMessage={this.state.meta.newPassword.errorMessage}
										onChange={genericOnChangeCreator(this, 'newPassword', this.validateNewPasswordOnChange)}
										onBlur={genericOnBlurCreator(this, 'newPassword', this.validateNewPasswordOnBlur)}
										validationIconClass="validationErrorIcon"
									/>
									<SimpleField name="verify_password"
										id="verifyPassword"
										label="Confirm new password"
										type="password"
										maxLength={65}
										value={this.state.values.verifyPassword}
										touched={this.state.meta.verifyPassword.touched}
										errorMessage={this.state.meta.verifyPassword.errorMessage}
										onChange={genericOnChangeCreator(this, 'verifyPassword', this.validateVerifyPassword)}
										onBlur={genericOnBlurCreator(this, 'verifyPassword', this.validateVerifyPassword)}
										validationIconClass="validationErrorIcon"
									/>
									<input className="ChangePasswordFormButton btn btn-primary btn-lg" style={{whiteSpace: 'normal'}} type="submit" value={ this.props.submitLabel ? this.props.submitLabel : 'Change Password & Log In' } />
								</div>
								<div className='ChangePasswordCriteria align-self-center col-12 col-lg-6'>
									<span>New password must meet the following criteria:</span>
									<ul>
										<li>Be at least 12 characters in length (administrators should be at least 16 characters)</li>
										<li>Contain at least one uppercase letter</li>
										<li>Contain at least one lowercase letter</li>
										<li>Contain at least one number</li>
										<li>Contain at least one special character: !,@,#,$,%,^,&,*,(,)</li>
										<li>Cannot match previous 6 passwords</li>
									</ul>
								</div>
							</div>
						</form>
					</div>
				</div>
				{Footer}
			</div>
		);
	}
}

ChangePasswordForm.propTypes = {
	onSubmitCallback: PropTypes.func.isRequired,
	formSubmissionSuccessful: PropTypes.bool.isRequired,
	formErrorMessage: PropTypes.string.isRequired,
	redirect: PropTypes.string.isRequired,
	submitLabel: PropTypes.string,
	hidePassword: PropTypes.bool,
	label: PropTypes.object
};

ChangePasswordForm.defaultProps = {
	hidePassword: false,
	label: {
		newPassword: 'New password must meet password criteria.',
		verifyPassword: 'New password and confirm new password must match.'
	}
};

export default ChangePasswordForm;
